export default function filterHotspot(hotspot, filters) {
  const type = hotspot?.type?.[0];
  const showOnSelection =
    hotspot?.show_on_selection === true ||
    hotspot?.show_on_selcetion === true;

  // Biorational
  if (filters.bioRational === true && type?.biorational === true) {
    return true;
  }

  // Catalogue
  if (filters.isSelection === false && type?.catalogue === true) {
    // Category
    if (
      filters.category === null ||
      filters.category === type?.product_category?.documentId
    ) {
      return true;
    }
  }

  // Selection
  if (filters.isSelection === true) {
    return showOnSelection;
  }

  return false;
}
